import { alpha } from '@mui/material/styles';
import { Button } from '@mui/material';
import { Box, Typography } from '@mui/material';
import { Modal } from '@mui/material';
import { Div } from 'Components/Div';
import { colors } from 'Constants/Colors';
import useTranslation from 'Hooks/useTranslation';
import styled from '@emotion/styled';

// ==============================
// = Components
// ==============================

const AcceptButton = styled(Button)({
  backgroundColor: colors.GREEN,
  color: colors.WHITE,
  '&:hover': {
    backgroundColor: colors.GREEN,
  },
});

const RejectButton = styled(Button)({
  backgroundColor: colors.RED,
  color: colors.WHITE,
  '&:hover': {
    backgroundColor: colors.RED,
  },
});

interface Props {
  saveModal: boolean;
  closeSaveModal: () => void;
  onSubmit: () => void;
}

const CoursesLessonsConfirmationModal = ({ saveModal, closeSaveModal, onSubmit }: Props) => {
  const { t2 } = useTranslation('courses_lessons');

  return (
    <Modal open={saveModal} onClose={closeSaveModal}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          backgroundColor: 'white',
          borderRadius: '15px',
          boxShadow: 24,
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Typography sx={{ fontSize: '16px', fontWeight: 'bold', color: colors.BLACK }}>
          {t2('confirmation_modal.title')}
        </Typography>
        <Typography sx={{ fontSize: '14px', color: alpha(colors.BLACK, 0.7) }}>
          {t2('confirmation_modal.description')}
        </Typography>
        <Div height="20px" />
        <Div display="flex" justifyContent="flex-end" gap="10px">
          <RejectButton variant="contained" onClick={closeSaveModal}>
            {t2('confirmation_modal.cancel')}
          </RejectButton>
          <AcceptButton variant="contained" onClick={onSubmit}>
            {t2('confirmation_modal.save')}
          </AcceptButton>
        </Div>
      </Box>
    </Modal>
  );
};

export default CoursesLessonsConfirmationModal;
